import { Interfaces as IAddressLookup } from '@service-victoria/component-library/components/AddressLookup/props';
import { OptionType } from '@service-victoria/component-library/components/AutoComplete/props';
import addressService from './addressService';

// https://nodejs.org/api/cli.html#cli_node_tls_reject_unauthorized_value
// if (process.env.NODE_ENV !== 'production') {
//   process.env.NODE_TLS_REJECT_UNAUTHORIZED = '0';
// }

/**
 * Rertrieve a list of addresses
 * @param baseURL domain address
 */
export function getAddressesLookup(baseURL: string): (search: string) => Promise<OptionType[]> {
  return new addressService(baseURL).getAddressesLookup;
}

/**
 * Static constant of search endpoint
 */
export const searchUri = addressService.searchUri;

/**
 * Retrieve the full details of the address
 * @param baseURL domain address
 */
export function getAddressDetails(
  baseURL: string
): (addressId: string, country: string) => Promise<IAddressLookup.ApiFullAddress> {
  return new addressService(baseURL).getAddressDetails;
}
